const { BASE_URL } = require("./client");

const GET_PRESIGNED_URL = BASE_URL + "/api/getPreSignedUrl";
const GET_DOWNLOAD_URL = BASE_URL + "/api/getDownloadUrl";
const GET_PRESIGNED_UPLOAD_URL = BASE_URL + "/api/getPreSignedUploadUrl";

module.exports = {
  GET_PRESIGNED_URL,
  GET_DOWNLOAD_URL,
  GET_PRESIGNED_UPLOAD_URL,
};
